import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { NoDataFoundTable, PageLoader } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Loader from "../../../img/Document scan.gif"
import { studySiteDataEntryServices } from "../../../APIServices/studySiteDataEntryServices";
import { studySubjectManagementServices } from "../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import Moment from "react-moment";
import Pagination from "../../Pagination";
import { CiSearch } from "react-icons/ci";
import SplitPane from "react-split-pane";

const SiteSubjectDiscontinueHistory = ({ onMouseDown, tableRef }) => {
  const [subjectDiscontinueHistory, setSubjectDiscontinueHistory] = useState([]);
  const [subjectDiscontinueHistoryCount, setSubjectDiscontinueHistoryCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [dataLoader, setDataLoader] = useState(false);
  let { studyId } = useParams();

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(subjectDiscontinueHistoryCount / itemsPerPage);

  const getStudySubjectDiscontinueHistoryData = async () => {
    setDataLoader(true);
    let data = await studySubjectManagementServices.getStudySubjectDiscontinueHistoryData(
      studyId,
      StudyMode,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setSubjectDiscontinueHistory(data?.data || [])
    setSubjectDiscontinueHistoryCount(data?.count || 0)
    setDataLoader(false);
  };

  const downloadCSV = (data) => {
    if (!data || !data.length) return;
    const headers = [
      "Sr.",
      "Study Id",
      "Site Id",
      "Subject Id",
      "Subject Status",
      "Category",
      "Reason",
      "Remark",
      "Activity by",
      "Activity Date | Time",
    ];
    const rows = data.map((row, index) => [
      index + 1,
      row.studyName || "",
      row.siteName || "",
      row.subjectName || "",
      row.subjectGender || "",
      "Discontinued",
      row.category || "",
      row.reason || "",
      row.remark || "",
      row.activityByName || "",
      row?.createdDT
    ]);
    const csvContent = [headers, ...rows]
      .map(row => row.map(val => `"${val}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "Discontinue_History.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  const downloadExcel = (data) => {
    if (!data || !data.length) return;
    const excelData = data.map((row, index) => ({
      "Sr.": index + 1,
      "Study Id": row.studyName,
      "Site Id": row.siteName,
      "Subject Id": row.subjectName,
      "Subject Status": "Discontinued",
      "category": row.category,
      "reason": row.reason,
      "remark": row.remark,
      "Activity By": row.activityByName,
      "Activity Date | Time": row?.createdDT,
    }));
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Subject Discontinue History");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, "subject_status.xlsx");
  };

  useEffect(() => {
    getStudySubjectDiscontinueHistoryData();
  }, [searchData, pageNumber, itemsPerPage]);

  return (
    <>
      <div className="justify-content-between toolbar border-bottom hstack p-1" style={{ height: 36 }}>
        <div className="hstack gap-1">
          {subjectDiscontinueHistoryCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "3px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 4, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <div className="gap-1 hstack">
            <button
              onClick={() => downloadCSV(subjectDiscontinueHistory)}
              className={`updateProfile`}
            >
              Download CSV
            </button>
            <button
              onClick={() => downloadExcel(subjectDiscontinueHistory)}
              className={`updateProfile`}
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>
      <SplitPane
        split="horizontal"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
      >
      {dataLoader ? (
        <PageLoader/>
      ) : subjectDiscontinueHistoryCount === 0 ? (
        <NoDataFoundTable MSG={"Data Not Found!"} />
      ) : subjectDiscontinueHistory?.length === 0 ? (
        <NoDataFoundTable MSG={"Search Data Not Found!"} />
      ) : (
        <>
          <div className="overflow-auto">
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th
                    onMouseDown={(e) => onMouseDown(e, 0)}
                    className="text-center"
                    style={{ width: 45 }}
                  >
                    Sr.
                  </th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Study Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Site Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Subject Id</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Subject Gender</th>
                  <th onMouseDown={(e) => onMouseDown(e, 4)}>Subject Status</th>
                  <th onMouseDown={(e) => onMouseDown(e, 5)}>Category</th>
                  <th onMouseDown={(e) => onMouseDown(e, 6)}>Reason</th>
                  <th onMouseDown={(e) => onMouseDown(e, 7)}>Remark</th>
                  <th onMouseDown={(e) => onMouseDown(e, 8)}>Activity By</th>
                  <th onMouseDown={(e) => onMouseDown(e, 9)}>Activity Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {(subjectDiscontinueHistory || []).map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>
                      {rowIndex + 1}
                    </td>
                    <td>{row?.studyName}</td>
                    <td>{row?.siteName}</td>
                    <td>{row?.subjectName}</td>
                    <td>{row?.subjectGender}</td>
                    <td className="text-danger fw-bold">Discontinued</td>
                    <td>{row?.category}</td>
                    <td>{row?.reason}</td>
                    <td>{row?.remark}</td>
                    <td>{row?.activityByName}</td>
                    <td>{row.createdDT}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="position-sticky bottom-0 start-0">
            <Pagination
              totalPage={totalPage}
              pageNumber={pageNumber}
              itemsPerPage={itemsPerPage}
              totalItems={subjectDiscontinueHistoryCount}
              setPageNumber={setPageNumber}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </>
      )}
      </SplitPane>
    </>
  );
};

export default SiteSubjectDiscontinueHistory;